import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '@shared/validators';
import { BaseComponent } from '@app/common/modules/base/base.component';
import { RecuperarSenhaController } from '@modules/auth/controllers';

interface LoginType {
  name: 'cpf' | 'cnpj' | 'email';
  type: string;
  label: string;
  icon: string;
  mask: string;
}

@Component({
  selector: 'app-recuperar-senha',
  templateUrl: './recuperar-senha.component.html',
  styleUrls: ['./recuperar-senha.component.scss'],
})
export class RecuperarSenhaComponent extends BaseComponent {
  public loginForm: FormGroup;
  public currentLoginType: LoginType | undefined;
  public isSubmitting = false;
  public isSubmitted = false;
  public hasError = false;

  public loginTypes: LoginType[] = [
    {
      name: 'cpf',
      type: 'text',
      label: 'CPF',
      icon: 'person',
      mask: '000.000.000-00',
    },
    {
      name: 'cnpj',
      type: 'text',
      label: 'CNPJ',
      icon: 'business',
      mask: 'AA.AAA.AAA/AAAA-99',
    },
    {
      name: 'email',
      type: 'email',
      label: 'E-mail',
      icon: 'email',
      mask: '',
    },
  ];

  constructor(
    public recuperarSenhaController: RecuperarSenhaController,
    private formBuilder: FormBuilder
  ) {
    super('Recuperar senha - Portal do Cliente');
    this.loginForm = this.createForm();
  }

  private createForm() {
    return this.formBuilder.group({
      login: ['', [Validators.required]],
    });
  }

  public changeLoginType(loginType: LoginType): void {
    const login = this.loginForm.get('login');

    if (!login) return;

    const validators = {
      cpf: [Validators.required, CustomValidators.cpf],
      cnpj: [Validators.required, CustomValidators.cnpj],
      email: [Validators.required, Validators.email],
    };

    login.reset();
    login.setValidators(validators[loginType.name]);
    login.updateValueAndValidity();

    this.currentLoginType = loginType;
  }

  public submit(): void {
    this.isSubmitting = true;
    this.hasError = false;
    this.isSubmitted = false;

    if (this.loginForm.valid && this.currentLoginType) {
      const data = {
        [this.currentLoginType.name]: this.loginForm.value.login,
      };

      this.recuperarSenhaController.recuperarSenha(data).subscribe({
        next: () => {
          this.isSubmitting = false;
          this.isSubmitted = true;
        },
        error: () => {
          this.isSubmitting = false;
          this.isSubmitted = false;
          this.hasError = true;
        }
      });
    }
  }
}
